import request from 'tools/request'
import { ENTITLEMENT_FLAGS } from 'constants/reporting'

interface FeatureFlagResponse {
  flagKey: string
  enabled: boolean
  description?: string
}

export interface ReportConfig {
  reportKey: string
  baseUrl: string
  reportType: string
  metadataJson?: Record<string, string>
}

export interface ReportingContext {
  flags: Record<string, boolean>
  reportConfigs: Record<string, ReportConfig>
}

export const fetchFeatureFlags = (
  prefix?: string
): Promise<Record<string, boolean>> =>
  request
    .get<FeatureFlagResponse[]>(
      `${process.env.REACT_APP_CARRIER_API_URL}feature-flags`,
      {
        params: prefix ? { prefix } : undefined,
      }
    )
    .then((r) =>
      Object.fromEntries((r.data ?? []).map((f) => [f.flagKey, !!f.enabled]))
    )

interface CompanyEntitlementsResponse {
  fleetFileUi: boolean
  fleetFileApi: boolean
  tripsDetailed: boolean
}

export const fetchEntitlements = (): Promise<Record<string, boolean>> =>
  request
    .get<CompanyEntitlementsResponse>(
      `${process.env.REACT_APP_CARRIER_API_URL}company/entitlements`
    )
    .then((r) => ({
      [ENTITLEMENT_FLAGS.FLEET_FILE_UI]: !!r.data?.fleetFileUi,
      [ENTITLEMENT_FLAGS.FLEET_FILE_API]: !!r.data?.fleetFileApi,
      [ENTITLEMENT_FLAGS.TRIPS_DETAILED]: !!r.data?.tripsDetailed,
    }))

export const fetchReportConfigs = (): Promise<Record<string, ReportConfig>> =>
  request
    .get<ReportConfig[]>(
      `${process.env.REACT_APP_CARRIER_API_URL}report-configs`
    )
    .then((r) =>
      Object.fromEntries((r.data ?? []).map((c) => [c.reportKey, c]))
    )
